import getRoutes from '@/lib/getRoutes'

const getRouteByBrand = async (brand: any): Promise<{ href: any; as: any }> => {
  return getRoutes({ route: 'Brand', values: { '[slug]': brand?.seo_name ?? brand.variant_id } })
}

export default getRouteByBrand
